import styled from '@emotion/styled';
import { Space } from 'antd';
import { memo } from 'react';
import { useTranslate } from '@tolgee/react';

const statusMap = {
  ENABLE: 'enable',
  DISABLE: 'disable',
} as const;

const CircleIcon = styled.div`
  width: 6px;
  aspect-ratio: 1/1;
  border-radius: 50%;
  &.enable {
    background-color: #56bb72;
  }
  &.sleep {
    background-color: #e7a53a;
  }
  &.disable {
    background-color: #b6b9bf;
  }
`;

interface AccountStatusProps {
  status: StoreHomeV2.AccountInDepartment['userStatus'];
  sleepFlag: boolean;
}

/**
 * [20240329]移除账号[休眠中]状态展示:
 * https://leyan.yuque.com/czpqnb/pd/fxygkbnwht1qxg8p#ZtWU0
 */
function AccountStatus(props: AccountStatusProps) {
  const { status } = props;
  const { t } = useTranslate();

  const statusLabelMap = {
    ENABLE: t('marketing.启用中'),
    DISABLE: t('department.已停用'),
  };

  return (
    <Space>
      <CircleIcon className={statusMap[status]} />
      {statusLabelMap[status]}
    </Space>
  );
}

export default memo(AccountStatus);
